import React from "react"
import InnerDropdownContainer from "../Admin/parts/InnerDropdownContainer"
import { HiArrowNarrowLeft } from "react-icons/hi";
import { Link } from "react-router-dom";

const Header = ({title, actions, innerDropdown, description, info, disable_inner_btn=false, prev=false, prevLink}) => {
    const style = {
        wrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "1.1em",
            flexWrap: "wrap"
        },
        title: {
            fontFamily: "Poppins-SemiBold",
            fontSize: "14px",
            color: "rgba(0,0,0,0.88)",
            fontWeight: "500",
            fontSize: "18px",
            marginTop: 0,
            marginBottom: 0,
            display: "flex",
            alignItems: "center"
        },
        p: {
            margin: '3px 0 0 0',
            fontFamily: 'Poppins-Regular',
            fontSize: '14px',
            fontWeight: 400,
            color: '#25313ccc',
        },
        info: {
            margin: '10px 0 0 0',
            fontFamily: 'Poppins-Regular',
            fontSize: '14px',
            fontWeight: 400,
            color: '#25313ccc',
        },
        prevIcon: {
            marginRight: "10px", 
            cursor: "pointer"
        },
        prevA: {
            color: 'rgba(0, 0, 0, 0.88)',
            display: 'flex',
            alignItems: 'center'
        }
    }

    return(
        <div style={style.wrapper}>
            <div>
                <h5 style={style.title}>
                    {prev && 
                        <Link to={prevLink} style={style.prevA}>
                            <HiArrowNarrowLeft 
                                style={style.prevIcon}
                            />
                        </Link>
                    }
                    {title}
                </h5>
                {innerDropdown && <InnerDropdownContainer disabled={disable_inner_btn}/>}
                {description && <p style={style.p}>{description}</p>}
                {info && <p style={style.info}>{info}</p>}
            </div>
            {actions}
        </div>
    )
}
export default Header